import { useI18n } from 'next-localization';

export const TypeaheadNoResults: React.FC<{ fieldName: string }> = ({ fieldName }) => {
  const { t } = useI18n();

  return (
    <div
      aria-live="polite"
      role="option"
      className="d-flex align-items-center p-1"
      aria-label={t('Search.Result.NoKeyword')}
      id={`${fieldName}-typeahead-noresults`}
    >
      <span className="neu-text-caption">{t('Search.Result.NoKeyword')}</span>
    </div>
  );
};
